const ORGANIZATIONS_TABLE_FIELDS = [
  {
    name: 'Organization Name',
    class: 'table-cell align-middle w-1/3 pl-8',
    displayField: 'name',
  },
  {
    name: 'Cause Area',
    class: 'table-cell align-middle w-1/3',
    displayField: 'causes',
  },
  {
    name: 'City',
    class: 'table-cell align-middle w-1/6',
    displayField: 'city',
  },
  {
    name: 'State',
    class: 'table-cell align-middle w-1/6 pr-8',
    displayField: 'state',
  },
]

export { ORGANIZATIONS_TABLE_FIELDS }
